<div class="container-fluid">
  <page-header-search
  [isSearchInput]="true"
  [pageTitleValue]="pageTitle"
  [placeholderValue]="placeholder"
  (onHeaderInputKeyup)="onSearchInputKeyup($event)"
  (onHeaderSearchSubmit)="onSearchTest($event)"
></page-header-search>

  <div class="card">
    <div class="card-body">
      <div class="table-title">
        <div class="col-7">
          <app-page-header-selections class="mb-0" 
            [headerSelections]="['All', 'Lab Test', 'Scan']" 
            title="All Latest Tests" (pageChanged)="changePageId($event)">
          </app-page-header-selections>
        </div>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div *ngIf="filteredTestArray?.length" class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="pointer"
              *ngFor="let item of filteredTestArray"
            >
              <td>
                <span>{{ item.name }}</span>
              </td>
              <td>
                <span>{{ item.arName }}</span>
              </td>
              <td>
                <span>{{ item.testTypeId == 1 ? 'Lab' : item.testTypeId == 2 ? 'Scan' : '' }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isCovid"
                      type="checkbox"
                      id="active-check"
                      (change)="onCovidChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isBundle"
                      type="checkbox"
                      id="active-check"
                      (change)="onBundleChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-warning mr-2"
                  type="button"
                  placement="top"
                  tooltip="Delete"
                  (click)="onDeleteTest($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-trash"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="fab-btn" [routerLink]="'/tests/add'">
  <i class="ni ni-fat-add"></i>
</div>
